import { render, staticRenderFns } from "./StatusMenu.vue?vue&type=template&id=40f28b44&scoped=true&"
import script from "./StatusMenu.vue?vue&type=script&lang=js&"
export * from "./StatusMenu.vue?vue&type=script&lang=js&"
import style0 from "./StatusMenu.vue?vue&type=style&index=0&id=40f28b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f28b44",
  null
  
)

export default component.exports